/* eslint-disable no-undef */
import { VFC, useEffect, useState } from 'react';

export const Marker: VFC<google.maps.MarkerOptions> = options => {
  const [marker, setMarker] = useState<google.maps.Marker>();

  useEffect(() => {
    const markerInstance = new google.maps.Marker();
    setMarker(markerInstance);
    return () => markerInstance.setMap(null);
  }, []);

  useEffect(() => {
    if (marker) {
      const { position, ...rest } = options;
      marker.setOptions({
        ...(position?.lat && position?.lng ? { position } : {}),
        ...rest,
      });
    }
  }, [marker, options]);

  return null;
};
